import { ROUTES } from './routes'

/**
 * F-65: `/admin/communities` (the list) and `/admin/communities/{id}` (the
 * detail). Both are static pages, never a section/space route.
 */
export const isAdminCommunitiesPath = (path: string): boolean => {
  const pathname = path.split(/[?#]/)[0].replace(/\/+$/, '')
  return pathname === ROUTES.adminCommunities || pathname.startsWith(ROUTES.adminCommunities + '/')
}

/** The community id of a detail path; `null` on the list and on the Pedidos tab (`/admin/communities/requests…`). */
export const adminCommunityIdOf = (path: string): string | null => {
  const pathname = path.split(/[?#]/)[0].replace(/\/+$/, '')
  if (!pathname.startsWith(ROUTES.adminCommunities + '/')) return null
  if (pathname === ROUTES.adminCommunityRequests || pathname.startsWith(ROUTES.adminCommunityRequests + '/')) return null
  const id = decodeURIComponent(pathname.slice(ROUTES.adminCommunities.length + 1).split('/')[0] || '')
  return id || null
}

export const adminCommunityPath = (id: string): string => `${ROUTES.adminCommunities}/${encodeURIComponent(id)}`
